import React, { useState } from "react";
import useRedeemCard from "./useRedeemCard";
import SuccessView from "./SuccessView";
import SEO from "../../components/Layout/SEO";

export default function RedeemCard() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const { redeem } = useRedeemCard();

  const handleRedeem = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    try {
      const res = await redeem(code.trim().toUpperCase());
      if (res) {
        setMessage({ success: true, msg: res.data?.message || "Your wallet has been credited successfully!" });
      } else {
        setMessage({ success: false, msg: "Invalid or expired coupon code. Please try again." });
      }
    } catch (err) {
      setMessage({ success: false, msg: "Something went wrong. Please try again." });
    }
    setLoading(false);
  };

  if (message) {
    return (
      <div className="redeem-page-wrap">
        <SuccessView message={message} onClose={() => { setMessage(null); setCode(""); }} />
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Redeem Card | TNS"
        description="Redeem your TNS gift card or coupon code to credit your wallet."
        url="https://newstand.tech/coupon/redeem-card"
      />
      <div className="redeem-page-wrap">
        <div className="redeem-page-inner">

          <div className="redeem-left">
            <div className="redeem-left-content">
              <div className="redeem-tag">Gift Card</div>
              <h1 className="redeem-title">
                Redeem Your<br />
                <span>TNS Gift Card</span>
              </h1>
              <p className="redeem-subtitle">
                Enter your code below to instantly credit your wallet and unlock access to hundreds of Nigerian newspapers, magazines and books.
              </p>
              <div className="redeem-perks">
                <div className="redeem-perk">
                  <div className="redeem-perk-icon">📰</div>
                  <div>
                    <strong>500+ Publications</strong>
                    <p>Access newspapers, magazines and books</p>
                  </div>
                </div>
                <div className="redeem-perk">
                  <div className="redeem-perk-icon">⚡</div>
                  <div>
                    <strong>Instant Credit</strong>
                    <p>Wallet credited immediately on redemption</p>
                  </div>
                </div>
                <div className="redeem-perk">
                  <div className="redeem-perk-icon">🎁</div>
                  <div>
                    <strong>Gift Someone</strong>
                    <p>Buy cards for friends and family</p>
                  </div>
                </div>
                <div className="redeem-perk">
                  <div className="redeem-perk-icon">💳</div>
                  <div>
                    <strong>Pay for Services</strong>
                    <p>Use wallet for Change of Name and more</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="redeem-right">
            <div className="redeem-card-box">
              <div className="redeem-card-icon">🎟️</div>
              <h2 className="redeem-card-title">Enter Your Code</h2>
              <p className="redeem-card-subtitle">
                Your code is usually 12–16 characters, printed on your gift card or sent via email.
              </p>
              <form onSubmit={handleRedeem}>
                <div className="redeem-input-wrap">
                  <input
                    type="text"
                    className="redeem-input"
                    placeholder="e.g. TNS-XXXX-XXXX-XXXX"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                    maxLength={20}
                    autoComplete="off"
                    spellCheck={false}
                  />
                </div>
                <button
                  type="submit"
                  className="redeem-submit-btn"
                  disabled={loading || !code.trim()}
                >
                  {loading ? "Redeeming..." : "Redeem Now"}
                </button>
              </form>
              <div className="redeem-help">
                <p>Don't have a gift card?</p>
                <a href="mailto:hello@thenewspaperstand.com">Contact support →</a>
              </div>
            </div>
            <div className="redeem-security">
              🔒 Secured & encrypted redemption
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
